<template>
  <div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" >
          <b-tab title="User Information" border-variant="primary" >
            <b-card border-variant="border">
              <div slot="header">
                <strong>Detail </strong>
                <span class="pull-right" v-if="!add && model.created_at">Created_at ({{model.created_at | sdate}} @ {{model.last_addr || '-'}})</span>
              </div>
              <b-row>
                <b-col md="3">
                  <b-form-group label="Allow login" label-for="ph_use"
                    v-b-tooltip.hover title="Allow login.">
                    <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Email verified" label-for="ph_active"
                    v-b-tooltip.hover title="Email verified.">
                    <c-switch color="info" label size="sm" v-model="model.is_verified" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="model.id">
                  <b-form-group>
                    <label>Last_visit</label>
                    <b-form-input type="text" :value="model.last_visit | datetime" plaintext></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_group" v-b-tooltip.hover title="Permission.">Permission(*)</label>
                    <v-select v-if="!lock" label="name" v-model="model.permissions" :options="codes.permissions_user"></v-select>
                    <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_nickname">Nickname(*)</label>
                    <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_username" v-b-tooltip.hover title="The username recommended E-mail address.">Username(ID)(*)</label>
                    <b-form-input @change="auto_set_nickname($event, model.username)" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-show="add || !lock">
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_pass">{{add ? 'User' : 'Change'}} Password(*)</label>
                    <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
                    <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                      Min Length : 10
                    </b-badge>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="model.new_password">
                  <b-form-group>
                    <label for="ph_pass2">Password Repeat(*)</label>
                    <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat"  :plaintext="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-badge variant="warning"> Info </b-badge>
              : If you set your password to blank, send a link to reset your password for 48 hours.
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">List of allowed IPs</label>
                    <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- start group info -->
              <hr>
              <strong v-if="model.group.id">Group(*)</strong>
              <hr v-if="model.group.id">
              <b-row v-if="model.group.id">
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_name">Group Name</label>
                    <b-form-input md=12 type="text" id="ph_name" v-model="model.group.groupname" :disabled="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="model.group.id">
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_service" v-b-tooltip.hover title="Service">Service</label>
                    <v-select v-if="add" :disabled="true" label="name" v-model="model.group.service" :options="codes.service_name"></v-select>
                    <h4 v-else>
                      <b-badge  :variant="model.group.service == 'Basic' ? 'info' : 'success'"> {{model.group.service}} </b-badge>
                    </h4>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Verified" label-for="ph_use"
                    v-b-tooltip.hover title="Verified Allow login.">
                    <c-switch color="info" label size="sm" v-model="model.group.is_verified" :disabled="true" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Member's" label-for="ph_count"
                    v-b-tooltip.hover title="Verified Allow login.">
                    {{model.group.count || 0}}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="model.group.id">
                <b-col md="4">
                  <b-form-group label="country" label-for="ph_country" v-b-tooltip.hover title="country.">
                    <v-select :readonly="true" :disabled="true" label="name" v-model="region.country" :options="codes.country" ></v-select>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="language" label-for="ph_language" v-b-tooltip.hover title="language.">
                    <v-select :readonly="true" :disabled="true" label="name" v-model="region.language" :options="codes.language"></v-select>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="timezone" label-for="ph_timezone" v-b-tooltip.hover title="timezone.">
                    <v-select :readonly="true" :disabled="true" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="model.group.id">
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_email" v-b-tooltip.hover title="Email">E-mail</label>
                    <b-form-input type="text" id="ph_email" :value="model.group.email" v-model="model.group.email" :disabled="true"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="contact" label-for="ph_contact" v-b-tooltip.hover title="contact.">
                    <b-form-input type="text" id="ph_contact" :value="model.group.contact" v-model="model.group.contact" :disabled="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="model.group.id">
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_address">Address</label>
                    <b-form-input md=12 type="text" id="ph_address" v-model="model.group.address" :disabled="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-tab>
          <b-tab title="Log Login" border-variant="primary" :disabled="!model.id">
            <!-- 해당 사용자의 로그인 목록 -->
            <log-Login-List v-if="model.id" :user="model"></log-Login-List>
          </b-tab>
          <!-- 해당 사용자의 액션 목록 -->
          <!-- <b-tab title="Log Action" border-variant="primary" :disabled="!model.id">
            <log-Action-List v-if="model.id" :user="model"></log-Action-List>
          </b-tab> -->
          </b-tabs>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import { Api, auth } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import reg from '@/reg'
import * as _ from 'lodash';

// another vue
import groupList from '../group/Group.List'
import logLoginList from '../../Log/login/Login.List.User'
import logActionList from '../../Log/action/Action.List.User'

const default_model = () => ({
  is_verified: true, group : { service : "Basic" }, permissions: 'User', username : '', new_password : '', new_password_repeat : '',
});

export default {
  props: ['user_id'],
  components: {
    logActionList,
    cSwitch,
    vSelect,
    groupList,
    logLoginList,
  },
  watch : {
    '$route' (to, from) { console.log("from : ", from);  this.get(to.params); },
  },
  data : () => ({
    codes,
    confirm: false,
    add: false,
    lock: true,
    group_list: undefined,
    model : default_model(),
    old_username : '',
    allowed: false,

    // group info side
    chainGroup : false,
    syncGroup : false,
    loadGroup : false,
    region : {
      language : codes.language_default,
      country : codes.country_default,
      timezone : codes.timezone_default
    },
    password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
    origin : { timezone : "", country : "", language : "" },

  }),
  computed: {
    border() { return !reg.email.test(this.model.username) || this.model.title == '' ? 'danger' : 'success'},
    TextLength() { return this.model.username.length > 0 ? true : false; },
    profile() { return auth.profile; }
  },
  methods: {
    async get() {
      this.model = default_model()
      if(!this.user_id) { return this.$toastr.e('incorrect target user') }
      // this.model.id = Number(this.user_id ? this.user_id : id);
      console.log('User.detail.summary.vue', 'load item', this.user_id);
      try{
        this.add = false;
        this.lock = true
        let rs = await Api.Manager_Call('user', 'detail', { id : this.user_id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(r.value == this.model.group.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(r.value == this.model.group.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(r.value == this.model.group.timezone) { this.region.timezone = r; is_done_timezone = true } });

        this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) }
    }
  },
  created() { console.log('User.Detail.Summary.vue', 'created'); },
  destroyed() { console.log('User.Detail.Summary.vue', 'destroyed'); },
  mounted() {
    console.log('User.Detail.Summary.vue', 'mounted');
    this.get();
  },
}
</script>
